<template>
<div id="app">
  <header id="header" class="clearfix" style="padding: 8px 0;">
    <h1 title=""><a href="/"><img src="/static/renew_img/logo.svg" alt=""><p class="pc">梅花女子大学</p><p class="sp">梅花女子大学</p></a></h1>
    <div class="btn_wrapper">
      <a v-if="$firebase.isAuthenticated" href="/mypage" class="btn_cta" >マイページ<img src="/static/renew_img/icon_home.svg" style="width: auto;" alt="マイページ"></a>
      <a v-else href="/login" class="btn_cta" >会員登録・ログイン<img src="/static/renew_img/icon_login.svg" style="width: auto;" alt="ログイン"></a>
    </div>
  </header>
  <router-view></router-view>
  <footer style="background-color: #0F9934;">
    <nav>
      <ol class="clearfix">
        <li>
          <a href="/info" >ヤギッシュの使い方
            <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></a>
        </li>
        <li>
          <a href="https://www.yagish.jp" target="_blank">会社概要
            <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp">
          </a>
        </li>
        <li>
          <router-link id="footer-link-terms"
                        :to="{name: 'termsPage'}">利用規約
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <router-link id="footer-link-policy"
                        :to="{name: 'policyPage'}">個人情報保護方針
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <router-link id="footer-link-help"
                        :to="{name: 'helpPage'}">ヘルプ<img src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp"></router-link>
        </li>
        <li>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform" target="_blank">お問い合わせ
          <img  src="/static/renew_img/icon_arrow_white.svg"  alt="詳しく見る" class="sp">
          </a>
        </li>
      </ol>
    </nav>
    <article>
      <ul>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-facebook" href="http://www.facebook.com/share.php?u=https://rirekisho.yagish.jp/" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-facebook.svg" alt="Facebookでシェア"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-line" href="http://line.me/R/msg/text/?ブラウザでつくれる履歴書 yagish（ヤギッシュ） https://rirekisho.yagish.jp/" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-line.svg" alt="LINEに送る"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-twitter" href="http://twitter.com/intent/tweet?url=https://rirekisho.yagish.jp/&amp;text=ブラウザでつくれる履歴書 yagish（ヤギッシュ）&amp;hashtags=yagish" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-twitter.svg" alt="Twiterでシェア"></a>
        </li>
        <li>
          <a data-v-ba1b8cd4="" id="footer-social-share-hatena" href="http://b.hatena.ne.jp/add?mode=confirm&amp;url=https://rirekisho.yagish.jp/&amp;title=ブラウザでつくれる履歴書 yagish（ヤギッシュ）" rel="nofollow" target="_blank"><img src="/static/renew_img/icon-hatena.svg" alt="はてなブックマーク"></a>
        </li>
      </ul>
      <p>©2021-2023 Yagish Co., Ltd. All rights reserved.</p>
    </article>
  </footer>
  <account-dialog />
  <eprint-dialog />
  <adtop-dialog />
  <cocorowa-dialog />
  <newgrade-dialog />
  <tempdata-dialog />
  <sendmail-dialog />
  <medley-dialog />
  <jigen-dialog />
  <tryt-dialog />
  <systemshared-dialog />
  <mynavi-ms-dialog />
  <jaic-dialog />
  <roxx-dialog />
  <athlete-dialog />
  <baton-dialog />
  <parttime-dialog />
  <yagishcareer-dialog />
  <realive-dialog />
  <jobs919-dialog />
  <introduction-dialog />
  <all-preview-dialog />
  <miraiyu-dialog />
  <yagioffer-dialog />
  <etc-dialog />
  <joblist-dialog />
  <loginform-dialog />
</div>
</template>

<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<script>
import EprintDialog from '@/components/EprintDialog'
import AdtopDialog from '@/components/AdtopDialog'
import SendMailDialog from '@/components/SendMailDialog'
import CocorowaDialog from '@/components/CocorowaDialog'
import NewGradeDialog from '@/components/NewGradeDialog'
import AccountDialog from '@/components/AccountDialog'
import TempDataDialog from '@/components/TempDataDialog'
import MedleyDialog from '@/components/MedleyDialog'
import JigenDialog from '@/components/JigenDialog'
import TrytDialog from '@/components/TrytDialog'
import MynaviMsDialog from '@/components/MynaviMsDialog'
import SystemSharedDialog from '@/components/SystemSharedDialog'
import JaicDialog from '@/components/JaicDialog'
import RoxxDialog from '@/components/RoxxDialog'
import BatonDialog from '@/components/BatonDialog'
import YagishCareerDialog from '@/components/YagishCareerDialog'
import AthleteDialog from '@/components/AthleteDialog'
import ParttimeDialog from '@/components/ParttimeDialog'
import Job919Dialog from '@/components/Job919Dialog'
import RealiveDialog from '@/components/RealiveDialog'
import IntroductionDialog from '@/components/IntroductionDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import MiraiyuDialog from '@/components/MiraiyuDialog'
import YagiOfferDialog from '@/components/YagiOfferDialog'
import EtcDialog from '@/components/EtcDialog'
import JoblistDialog from '@/components/JobListDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
export default {
  components: {
    'eprint-dialog': EprintDialog,
    'account-dialog': AccountDialog,
    'adtop-dialog': AdtopDialog,
    'cocorowa-dialog': CocorowaDialog,
    'newgrade-dialog': NewGradeDialog,
    'tempdata-dialog': TempDataDialog,
    'sendmail-dialog': SendMailDialog,
    'medley-dialog': MedleyDialog,
    'jigen-dialog': JigenDialog,
    'roxx-dialog': RoxxDialog,
    'tryt-dialog': TrytDialog,
    'mynavi-ms-dialog': MynaviMsDialog,
    'systemshared-dialog': SystemSharedDialog,
    'jaic-dialog': JaicDialog,
    'baton-dialog': BatonDialog,
    'parttime-dialog': ParttimeDialog,
    'jobs919-dialog': Job919Dialog,
    'yagishcareer-dialog': YagishCareerDialog,
    'athlete-dialog': AthleteDialog,
    'realive-dialog': RealiveDialog,
    'miraiyu-dialog': MiraiyuDialog,
    'introduction-dialog': IntroductionDialog,
    'all-preview-dialog': AllPreviewDialog,
    'yagioffer-dialog': YagiOfferDialog,
    'etc-dialog': EtcDialog,
    'joblist-dialog': JoblistDialog,
    'loginform-dialog': LoginFormDialog
  },
  methods: {
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    }
  },
  computed: {
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return (this.$route.name === 'top')
    },
    isMynabi: function () {
      this.checkMynabi()
      return (this.$yagi.isFromMynabi === 1)
    },
    isEditingFormat: function () {
      return (this.$route.name === 'formatEditCard')
    },
    needsFullScreen: function () {
      return (this.$route.name === 'formatPreview')
    },
    needsFooter: function () {
      if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
        return false
      }
      return true
    }
  }
}
</script>
